import Vue from 'vue'
import { POSITION } from 'vue-toastification'

const toastOptions = {
  timeout: 5000,
  position:  POSITION.BOTTOM_RIGHT,
}

export default {
  success(message, options = toastOptions) {
    Vue.prototype.$toast.success(message, options)
  },
  error(message, options = { ...toastOptions, timeout: 10000 }) {
    Vue.prototype.$toast.error(message, options)
  },
  warning(message, options = toastOptions) {
    Vue.prototype.$toast.warning(message, options)
  },
  info(message, options = toastOptions) {
    Vue.prototype.$toast.info(message, options)
  },
  show(message, options = toastOptions) {
    Vue.prototype.$toast(message, options)
  },
  debug(message, options = toastOptions) {
    Vue.prototype.$toast(message, options)
  },
  clear() {
    Vue.prototype.$toast.clear()
  },
}
